import _ from "lodash";
export function excludeUnselectableRows(selectedRowIds, unselectableRowIds) {
    if (unselectableRowIds && unselectableRowIds.length) {
        const filteredSelectedRowsId = { ...selectedRowIds };
        unselectableRowIds.forEach((id) => {
            delete filteredSelectedRowsId[id];
        });
        return filteredSelectedRowsId;
    }
    return selectedRowIds;
}
export function shouldExcludeUnselectableRows(allowSelection, previousUnselectableRowIds, currentUnselectableRowIds) {
    return !_.isEqual(currentUnselectableRowIds, previousUnselectableRowIds) && allowSelection;
}
